<template>
  <div>
    <form v-on:submit.prevent="addUser()" id="form">
      <h1>Registo</h1>
      <div class="form-group">
        <label for="email">Email*</label>
        <input
          type="email"
          class="form-control"
          id="email"
          aria-describedby="emailHelp"
          placeholder="Insira email do utilizador"
          required
          v-model="email"
        />
      </div>
      <div class="form-group">
        <label for="username">Nome*</label>
        <input
          type="text"
          class="form-control"
          id="username"
          aria-describedby="emailHelp"
          placeholder="Insira o nome do utilizador"
          required
          v-model="username"
        />
      </div>
      <div class="form-group">
        <label for="password">Password*</label>
        <input
          type="password"
          class="form-control"
          id="password"
          placeholder="Password"
          required
          v-model="password"
        />
      </div>
      <div class="form-group">
        <label for="confPassword">Confirmar Password*</label>
        <input
          type="password"
          class="form-control"
          id="confPassword"
          placeholder="Confirmar Password"
          required
          v-model="confPassword"
        />
      </div>
      <small>*Campos obrigatórios</small> <br />
      <button type="submit" class="btn btn-primary float-right">
        Adicionar
      </button>
    </form>
    {{ email }}
    {{ password }}
    {{ confPassword }}
    {{ username }}
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      email: "",
      username: "",
      password: "",
      confPassword: "",
    };
  },
  methods: {
    async addUser() {
      try {
        await this.$store.dispatch("postUser", {
          username: this.username,
          email: this.email,
          password: this.password,
          confPassword: this.confPassword,
        });
      } catch (err) {
        this.$swal({
          title: err.data.status,
          icon: "error",
          confirmButtonText: "Ok!",
        });
      }
    },
  },
};
</script>
<style scoped>
label {
  font-size: 18px;
}
#form {
  text-align: left;
  padding: 50px 60px 0px 300px;
}
</style>
